import { useState, useEffect, useRef } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { generateSmsCode, VerifySmsCode, registerbyPhoneNumber, generateEmailCode, VerifyEmailCode, registerbyEmail } from "../services/api";
import {
  validateRegisterStep1Form,
  validatePhoneNumberbyCode,
  validatePhoneNumberbyCode2,
} from "../utils/validation";
import Cookies from "js-cookie";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { Box, Typography, Button, CircularProgress } from "@mui/material";
import { useTranslation } from 'react-i18next';
import tokenManager from "../services/tokenManager";

const LOGGED_OUT_FLAG = "logged_out";

const Login = ({ initialTab }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(initialTab || "register");
  const [PhoneLoginPathway, setPhoneLoginPathway] = useState(false);
  const [PhoneRegisterPathway, setPhoneRegisterPathway] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [loading, setLoading] = useState(true);
  const [SubmitLoading, setSubmitLoading] = useState(false);
  const [registerData, setRegisterData] = useState({
    lastName: "",
    firstName: "",
    phoneNumber: "",
    email: "",
  });
  const [newUser, setNewUser] = useState(false);

  const [formErrors, setFormErrors] = useState({});
  const [formErrors2, setFormErrors2] = useState("");
  const [registerStep, setRegisterStep] = useState(1);
  const [PhoneRegisterData, setPhoneRegisterData] = useState({ phoneCode: "+852", phoneNumber2: "" });
  const [code, setCode] = useState(["", "", "", "", "", ""]);
  const inputRefs = useRef(new Array(6).fill(null));
  const [countdown, setCountdown] = useState(0); // Set initial countdown value
  const [isDisabled, setIsDisabled] = useState(false);
  const [agreeToTerms, setAgreeToTerms] = useState(false);

  const handleChange = (index, value) => {
    setFormErrors2("");
    const newValue = value.replace(/\D/g, "").slice(0, 1);
    const newCode = [...code];
    newCode[index] = newValue;
    setCode(newCode);

    // Move focus to next input if a digit is entered
    if (newValue && index < 5 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }

    // Check if all fields are filled
    if (newCode.every((digit) => digit)) {
      newCode.join("");
      setLoading(true);
      if (PhoneLoginPathway) {
        VerifySmsCode(PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2, newCode.join(""))
          .then((response) => {
            if (response.status === 200 && response.data?.data) {
              const apiData = response.data.data;

              // Check if new user needs to complete registration
              if (apiData.isNewUser === true) {
                setNewUser(true);
                setRegisterStep(1);
                setActiveTab('register-2');
                setPhoneRegisterPathway(true);
                setLoading(false);
                // Store phone data for registration
                setPhoneRegisterData(prev => ({
                  ...prev,
                  phoneNumber2: PhoneRegisterData.phoneNumber2
                }));
                return;
              }

              // Existing user - auto-login
              if (apiData.token) {
                const token = apiData.token;
                localStorage.removeItem(LOGGED_OUT_FLAG);
                tokenManager.setAuthToken(token);
                Cookies.set("token", token);

                const userId = apiData.userId || jwtDecode(token).userId;
                const userRole = apiData.role || jwtDecode(token).userRole;

                tokenManager.setUserId(userId?.toString());
                tokenManager.setUserRole(userRole);
                Cookies.set("id", userId?.toString());
                Cookies.set("role", userRole);

                navigate("/hotel/onboarding");
              }
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            setLoading(false);
            if (error.status === 400) {
              setFormErrors2(t('UnabletoVerifyNumber'));
            }
          });
      }
      else {
        VerifyEmailCode(registerData.email, (newCode.join("")))
          .then((response) => {
            if (response.status === 200 && response.data?.data) {
              const apiData = response.data.data;

              // Check if new user needs to complete registration
              if (apiData.isNewUser === true) {
                setNewUser(true);
                setRegisterStep(1);
                setActiveTab('register-2');
                setLoading(false);
                setPhoneRegisterPathway(false);
                setSubmitLoading(false);
                return;
              }

              // Existing user - auto-login
              if (apiData.token) {
                const token = apiData.token;
                localStorage.removeItem(LOGGED_OUT_FLAG);
                tokenManager.setAuthToken(token);
                Cookies.set("token", token);

                const userId = apiData.userId || jwtDecode(token).userId;
                const userRole = apiData.role || jwtDecode(token).userRole;

                tokenManager.setUserId(userId?.toString());
                tokenManager.setUserRole(userRole);
                Cookies.set("id", userId?.toString());
                Cookies.set("role", userRole);

                navigate("/hotel/onboarding");
              }
            }
          })
          .catch((error) => {
            setLoading(false);
            if (error.status === 400) {
              setFormErrors2(t('UnabletoVerifyEmail'));
            }
            if (error.status === 410) {
              setFormErrors2(t('VerificationCodeExpired'));
            }
          });
      }
    }
  };

  // Handle key down (e.g., backspace to move to previous input)
  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && !code[index] && index > 0 && inputRefs.current[index - 1]) {
      const newCode = [...code];
      newCode[index - 1] = "";
      setCode(newCode);
      inputRefs.current[index - 1].focus();
    }
  };

  useEffect(() => {
    if (
      formErrors.email === "請輸入有效的電郵地址" ||
      formErrors.email === "Please enter a valid email"
    ) {
      setFormErrors((prev) => ({
        ...prev,
        email: t('InvalidEmail'),
      }));
    }
    if (
      formErrors.email === "請輸入電郵地址" ||
      formErrors.email === "Please enter email"
    ) {
      setFormErrors((prev) => ({
        ...prev,
        email: t('EnterEmail'),
      }));
    }
    if (
      formErrors.existedUser === "此電郵信箱已註冊" ||
      formErrors.existedUser === "This email address is already registered"
    ) {
      setFormErrors((prev) => ({
        ...prev,
        existedUser: t('ExistedUser'),
      }));
    }
    if (
      formErrors.existedUser2 === "此電話號碼已註冊" ||
      formErrors.existedUser2 === "This phone number is already registered"
    ) {
      setFormErrors((prev) => ({
        ...prev,
        existedUser2: t('ExistedUser2'),
      }));
    }
    if (
      formErrors2 === "聯絡電話只能包含數字" ||
      formErrors2 === "Phone number can only contain numbers"
    ) {
      setFormErrors2(t('OnlyNumbers'));
    }
    if (
      formErrors2 === "請輸入有效的電話號碼" ||
      formErrors2 === "Please enter a valid phone number"
    ) {
      setFormErrors2(t('InvalidPhoneNumber'));
    }
    if (
      formErrors2 === "驗證碼已過期" ||
      formErrors2 === "Verification code has expired"
    ) {
      setFormErrors2(t('VerificationCodeExpired'));
    }
    if (
      formErrors2 === "抱歉，我們無法驗證此程式碼。請確保您輸入了正確的電子郵件地址和驗證碼。" ||
      formErrors2 === "Sorry, we are not able to verify the code. Please make sure you input the right email and code."
    ) {
      setFormErrors2(t('UnabletoVerifyEmail'));
    }
    if (
      formErrors2 === "很抱歉，我們無法驗證此代碼。請確保你輸入正確的電話號碼和驗證碼。" ||
      formErrors2 === "Sorry, we are not able to verify the code. Please make sure you input the right phone number and code."
    ) {
      setFormErrors2(t('UnabletoVerifyNumber'));
    }
    // Do not reset to "" here, only translate if needed
    // If you want to clear errors on language change, do it in a separate effect
  }, [t]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Focus the first input on component mount
  useEffect(() => {
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  // 检查屏幕是否为移动尺寸
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // 初始检查
    checkMobile();

    // 为窗口调整大小添加事件监听器
    window.addEventListener("resize", checkMobile);

    // 清理
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  //scrolled to top and loading screen
  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (countdown > 0) {
      setIsDisabled(true);
      const timer = setInterval(() => {
        setCountdown(prevCountdown => prevCountdown - 1);
      }, 1000);

      return () => clearInterval(timer); // Cleanup on unmount
    }
    setIsDisabled(false);
  }, [countdown]);

  useEffect(() => {
    if (PhoneRegisterData !== null && PhoneRegisterData.phoneNumber2) {
      setRegisterData((prev) => ({
        ...prev,
        phoneNumber: PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2,
      }));
    }
  }, [PhoneRegisterData]);

  // Step 1: Email validation and continue
  const handleRegisterEmailContinue = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const validation = validateRegisterStep1Form(registerData);
    if (!validation.isValid) {
      setSubmitLoading(false);
      if (validation.errors.email === "請輸入有效的電郵地址") {
        setFormErrors({ email: t('InvalidEmail') });
      }
      return;
    }

    try {
      const response = await generateEmailCode(registerData.email);
      if (response.status === 200) {
        setCountdown(59);
        setSubmitLoading(false);
        setActiveTab("register-email-code-tab");
      }
    } catch (error) {
      setSubmitLoading(false);
      setFormErrors("再檢查你個電話號碼");
    }
    // setRegisterStep(2);
  };

  const reGenerateEmailCode = async (e) => {
    e.preventDefault();
    setCountdown(59);
    setIsDisabled(true);

    try {
      await generateEmailCode(registerData.email);
    } catch (error) {
      setFormErrors("再檢查你個電話號碼");
    }
  };

  const reGenerateSmsCode = async (e) => {
    e.preventDefault();
    setCountdown(59);
    setIsDisabled(true);

    try {
      await generateSmsCode(PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2);
    } catch (error) {
      setFormErrors2("再檢查你個電話號碼");
    }
  };


  // Step 2: Complete registration
  const handleRegister = async (e) => {
    e.preventDefault();
    setFormErrors({});
    setFormErrors2("");
    setSubmitLoading(true);
    setRegisterData((prev) => ({
      ...prev,
      phoneNumber: PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2,
    }));

    const validation = validatePhoneNumberbyCode2(PhoneRegisterData, t);
    if (validation !== "") {
      setFormErrors2(validation);
      setSubmitLoading(false);
      return;
    }

    try {
      const { data } = await registerbyEmail(registerData);
      if (data.success && data.data?.token) {
        // Registration successful with token - auto-login
        const token = data.data.token;
        localStorage.removeItem(LOGGED_OUT_FLAG);
        tokenManager.setAuthToken(token);
        Cookies.set("token", token);

        const userId = data.data.userId || jwtDecode(token).userId;
        const userRole = data.data.role || jwtDecode(token).userRole;

        tokenManager.setUserId(userId?.toString());
        tokenManager.setUserRole(userRole);
        Cookies.set("id", userId?.toString());
        Cookies.set("role", userRole);

        setSubmitLoading(false);

        navigate("/hotel/onboarding");
      }
    } catch (error) {
      setSubmitLoading(false);
      if (error.status === 409) {
        setFormErrors({ existedUser2: t('ExistedUser') });
      } else if (error.response?.data?.error) {
        setFormErrors({ api: error.response.data.error });
      } else {
        setFormErrors({ api: t('RegistrationFail') });
      }
    }
  };

  //registration by phone number
  const handleRegisterViaPhone = async (e) => {
    e.preventDefault();
    setSubmitLoading(true);

    const validation = validatePhoneNumberbyCode(PhoneRegisterData);
    if (validation !== "") {
      setFormErrors2(validation);
      setSubmitLoading(false);
      return;
    }

    try {
      const response = await generateSmsCode(PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2);
      console.log(response);
      if (response.status === 201 && !response.data.newUser) {
        setCountdown(59);
        setPhoneLoginPathway(true);
        setSubmitLoading(false);
        setActiveTab("register-sms-code-tab");
      }
    } catch (error) {
      setSubmitLoading(false);
      setFormErrors("再檢查你個電話號碼");
    }
  };

  const errorMessageStyle = {
    color: "#F10000",
    fontSize: "14px",
    marginTop: "-15px",
    marginBottom: "10px",
    display: "block",
  };

  const pageStyle = {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  };

  const contentStyle = {
    flex: "1 0 auto",
    position: "relative",
    width: "100%",
    paddingTop: "60px",
  };

  const catImageStyle = {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    objectPosition: "center center",
    display: "block",
    transition: "transform 0.2s linear",
    willChange: "transform",
    position: "absolute",
    top: 0,
    left: 0,
    zIndex: 0,
  };

  const desktopFormContainerStyle = {
    position: "absolute",
    top: "50%",
    left: "20%",
    transform: "translate(-50%, -50%)",
    width: "420px",
    padding: "30px",
    zIndex: 1,
  };

  const mobileFormContainerStyle = {
    width: "85%",
    maxWidth: "400px",
    margin: "20px auto",
    padding: "20px",
    backgroundColor: "#FCF8F3CC",
    borderRadius: "10px",
    zIndex: 1,
  };

  const formTitleStyle = {
    fontSize: isMobile ? "26px" : "var(--font-size-xxl)",
    fontWeight: "bold",
    marginBottom: "5px",
    marginTop: "0",
    textAlign: "left",
  };

  const toggleLinkStyle = {
    fontSize: isMobile ? "var(--font-size-xs)" : "var(--font-size-base)",
    color: "var(--color-text)",
    marginBottom: "20px",
    display: "block",
    textAlign: "left",
  };

  const toggleLinkSpanStyle = {
    color: "var(--color-primary)",
    cursor: "pointer",
  };

  const labelStyle = {
    display: "block",
    fontSize: isMobile ? "13px" : "18px",
    marginBottom: "8px",
  };

  const inputStyle = {
    width: "100%",
    padding: "10px 12px",
    marginBottom: "8px",
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    boxSizing: "border-box",
    fontSize: isMobile ? "12px" : "16px",
    fontFamily: "Right Code,monospace",
    backgroundColor: "white",
  };

  const VerificationCodeContainer = {
    display: "flex",
    gap: "8px",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "20px",
  };

  const VerificationCodeInput = {
    width: isMobile ? "40px" : "50px",
    height: isMobile ? "40px" : "50px",
    border: "2px solid #ccc",
    borderRadius: "10px",
    textAlign: "center",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#31BACD",
  };

  const selectStyle = {
    width: isMobile ? "90px" : "110px",
    padding: isMobile ? "10px 8px" : "11px 12px",
    marginBottom: "8px",
    border: "1px solid #e0e0e0",
    borderRadius: "10px",
    boxSizing: "border-box",
    fontSize: isMobile ? "12px" : "16px",
    fontFamily: "Right Code,monospace",
    backgroundColor: "white",
    appearance: "none",
    backgroundImage: `url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23666' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e")`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "right 8px center",
    backgroundSize: "16px",
    paddingRight: "32px",
    cursor: "pointer",
  };

  const mobileBgStyle = {
    backgroundImage: 'url("/img/login.jpeg")',
    backgroundSize: "cover",
    backgroundPosition: "70% center",
    minHeight: "80vh",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  };

  const mobileLogoStyle = {
    fontSize: "32px",
    fontWeight: "bold",
    marginBottom: "20px",
    textAlign: "center",
  };

  const [loginMethod, setLoginMethod] = useState("email");

  const renderRegisterStep1 = () => (
    <div>
      <h2 style={{ fontWeight: 700, fontSize: 22, marginBottom: 16 }}>
        {t('Welcometitle')}
      </h2>

      {/* Tab Interface */}
      <div style={{
        display: "flex",
        marginBottom: "32px",
        borderRadius: "10px",
        backgroundColor: "#E2E8F0",
        padding: "4px",
        position: "relative",
      }}>
        {/* Sliding background indicator */}
        <div style={{
          position: "absolute",
          top: "4px",
          left: loginMethod === "email" ? "4px" : "calc(50% - 2px)",
          width: "calc(50% - 4px)",
          height: "calc(100% - 8px)",
          backgroundColor: "#fff",
          borderRadius: "10px",
          boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
          transition: "left 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          zIndex: 0,
        }} />

        <div
          onClick={() => setLoginMethod("email")}
          style={{
            flex: 1,
            padding: "10px 16px",
            textAlign: "center",
            cursor: "pointer",
            color: loginMethod === "email" ? "#000" : "#6B7280",
            fontWeight: loginMethod === "email" ? "600" : "normal",
            transition: "color 0.3s ease, font-weight 0.3s ease",
            fontSize: isMobile ? "12px" : "16px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {t('email')}
        </div>
        <div
          onClick={() => setLoginMethod("phone")}
          style={{
            flex: 1,
            padding: "10px 16px",
            textAlign: "center",
            cursor: "pointer",
            color: loginMethod === "phone" ? "#000" : "#6B7280",
            fontWeight: loginMethod === "phone" ? "600" : "normal",
            transition: "color 0.3s ease, font-weight 0.3s ease",
            fontSize: isMobile ? "14px" : "16px",
            position: "relative",
            zIndex: 1,
          }}
        >
          {t('phoneNumber')}
        </div>
      </div>

      {loginMethod === "email" ? (
        <form onSubmit={handleRegisterEmailContinue}>
          <label style={labelStyle}>{t('PleaseEnterEmail')}</label>
          <input
            type="email"
            placeholder="example@mail.com"
            value={registerData.email}
            onChange={(e) =>
              setRegisterData({
                ...registerData, email: e.target.value,
                ...(registerData.email && setFormErrors({})),
              })
            }
            style={inputStyle}
            required
          />
          {formErrors.email && (
            <div style={{ color: "#f10000", fontSize: 14, marginBottom: 8 }}>
              {formErrors.email}
            </div>
          )}
          <label
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "8px",
              fontWeight: 500,
              fontSize: 12,
              padding: "10px 0",
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
              style={{ marginTop: "2px", cursor: "pointer", flexShrink: 0 }}
            />
            <span>
              {t('RegistrationInfo')} <a className="text-blue-600" href="/terms" target="_blank">{t('Terms&Conditions')}</a>
            </span>
          </label>

          <Button
            variant="contained"
            type="submit"
            sx={{
              width: "100%",
              padding: "12px",
              backgroundColor: registerData.email ? "#31BACD" : "#ccc",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
              fontWeight: "bold",
              cursor: "pointer",
              marginTop: "10px",
              boxShadow: "none",
              "&:hover": { opacity: 0.8, backgroundColor: registerData.email ? "#31BACD" : "#ccc" },
              "&:disabled": { opacity: 0.6, backgroundColor: "#ccc" },
              cursor: SubmitLoading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              textTransform: 'none',
            }}
            disabled={SubmitLoading || !agreeToTerms}
          >
            {t('Continue')}
            {SubmitLoading && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <CircularProgress size={20} color="inherit" />
              </span>
            )}
          </Button>
        </form>
      ) : (
        <form onSubmit={handleRegisterViaPhone}>
          <label style={labelStyle}>{t('PleaseEnterPhoneNumber')}</label>
          <div style={{ display: 'flex', gap: '10px', marginBottom: '15px' }}>
            <select
              style={selectStyle}
              value={PhoneRegisterData.phoneCode}
              onChange={(e) =>
                setPhoneRegisterData({ ...PhoneRegisterData, phoneCode: e.target.value })
              }
              renderValue={(value) => value}
              required
            >
              <option value="+852">+852</option>
              <option value="+853">+853</option>
              <option value="+86">+86</option>
              <option value="+865">+865</option>
              <option value="+81">+81</option>
              <option value="+880">+880</option>
            </select>
            <input
              type="tel"
              placeholder={t('phoneNumber')}
              style={inputStyle}
              value={PhoneRegisterData.phoneNumber2}
              onChange={(e) =>
                setPhoneRegisterData({
                  ...PhoneRegisterData, phoneNumber2: e.target.value,
                  ...(PhoneRegisterData.phoneNumber2 && setFormErrors2("")),
                })
              }
              required
            />
          </div>

          {formErrors2 && (
            <span style={errorMessageStyle}>{formErrors2}</span>
          )}
          <label
            style={{
              display: "flex",
              alignItems: "flex-start",
              gap: "8px",
              fontWeight: 500,
              fontSize: 12,
              padding: "10px 0",
              cursor: "pointer",
            }}
          >
            <input
              type="checkbox"
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
              style={{ marginTop: "2px", cursor: "pointer", flexShrink: 0 }}
            />
            <span>
              {t('RegistrationInfo')} <a className="text-blue-600" href="/terms" target="_blank">{t('Terms&Conditions')}</a>
            </span>
          </label>

          <Button
            variant="contained"
            type="submit"
            sx={{
              width: "100%",
              padding: "12px",
              backgroundColor: PhoneRegisterData.phoneNumber2 ? "#31BACD" : "#ccc",
              color: "#fff",
              border: "none",
              borderRadius: "10px",
              fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
              fontWeight: "bold",
              cursor: "pointer",
              marginTop: "10px",
              boxShadow: "none",
              "&:hover": { opacity: 0.8, backgroundColor: PhoneRegisterData.phoneNumber2 ? "#31BACD" : "#ccc" },
              "&:disabled": { opacity: 0.6, backgroundColor: "#ccc" },
              cursor: SubmitLoading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "10px",
              textTransform: 'none',
            }}
            disabled={SubmitLoading || !agreeToTerms}
          >
            {t('Continue')}
            {SubmitLoading && (
              <span
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <CircularProgress size={20} color="inherit" />
              </span>
            )}
          </Button>
        </form>
      )}
    </div>
  );

  // Registration Step 2 UI
  const renderRegisterStep2 = () => (
    <div>
      <h2 style={{ fontWeight: 700, fontSize: 32, marginBottom: 8 }}>
        {t('CompleteRegistration')}
      </h2>
      <form onSubmit={handleRegister}>
        {formErrors.existedUser && (
          <div style={{ color: "#f10000", fontSize: 14, marginBottom: 8 }}>
            {formErrors.existedUser}
          </div>
        )}
        {formErrors.existedUser2 && (
          <div style={{ color: "#f10000", fontSize: 14, marginBottom: 8 }}>
            {formErrors.existedUser2}
          </div>
        )}
        <label
          style={{
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 8,
            display: "block",
          }}
        >
          {t('LastName')}
        </label>
        <input
          type="text"
          placeholder={t('LastName')}
          value={registerData.lastName}
          onChange={(e) =>
            setRegisterData({ ...registerData, lastName: e.target.value })
          }
          style={inputStyle}
          required
        />
        <label
          style={{
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 8,
            display: "block",
          }}
        >
          {t('FirstName')}
        </label>
        <input
          type="text"
          placeholder={t('FirstName')}
          value={registerData.firstName}
          onChange={(e) =>
            setRegisterData({ ...registerData, firstName: e.target.value })
          }
          style={inputStyle}
          required
        />
        <label style={{
          fontWeight: 500,
          fontSize: 16,
          marginBottom: 8,
          display: "block",
        }}>{t('phoneNumber')}</label>
        <div style={{ display: 'flex', gap: '10px', marginBottom: 10 }}>
          <select
            style={selectStyle}
            value={PhoneRegisterData.phoneCode}
            onChange={(e) =>
              setPhoneRegisterData({ ...PhoneRegisterData, phoneCode: e.target.value })
            }
            renderValue={(value) => value}
            required={PhoneRegisterPathway}
          >

            <option value="+852">+852</option>
            <option value="+853">+853</option>
            <option value="+86">+86</option>
            <option value="+865">+865</option>
            <option value="+81">+81</option>
            <option value="+880">+880</option>
          </select>
          <input
            type="tel"
            placeholder={t('phoneNumber')}
            style={inputStyle}
            value={PhoneRegisterData.phoneNumber2}
            onChange={(e) => {
              setPhoneRegisterData({ ...PhoneRegisterData, phoneNumber2: e.target.value });
              if (e.target.value) setFormErrors2("");
            }}
            required={PhoneRegisterPathway}
          />
        </div>
        {formErrors2 && (<span style={errorMessageStyle}>{formErrors2}</span>)}
        <label
          style={{
            fontWeight: 500,
            fontSize: 16,
            marginBottom: 8,
            display: "block",
          }}
        >
          {t('email')}
        </label>
        <input
          type="email"
          placeholder="example@mail.com"
          value={registerData.email}
          onChange={(e) =>
            setRegisterData({ ...registerData, email: e.target.value })
          }
          style={inputStyle}
          required={!PhoneRegisterPathway}
        />
        {formErrors.email && (
          <div style={{ color: "#f10000", fontSize: 14, marginBottom: 8 }}>
            {formErrors.email}
          </div>
        )}
        <label
          style={{
            display: "flex",
            alignItems: "flex-start",
            gap: "8px",
            fontWeight: 500,
            fontSize: 12,
            padding: "10px 0",
            cursor: "pointer",
          }}
        >
          <input
            type="checkbox"
            checked={agreeToTerms}
            onChange={(e) => setAgreeToTerms(e.target.checked)}
            style={{ marginTop: "2px", cursor: "pointer", flexShrink: 0 }}
          />
          <span>
            {t('RegistrationInfo')} <a className="text-blue-600" href="/terms" target="_blank">{t('Terms&Conditions')}</a>
          </span>
        </label>

        <Button
          variant="contained"
          type="submit"
          sx={{
            width: "100%",
            padding: "12px",
            backgroundColor: "#31BACD",
            color: "#fff",
            border: "none",
            borderRadius: "10px",
            fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
            fontWeight: "bold",
            cursor: "pointer",
            marginTop: "10px",
            boxShadow: "none",
            "&:hover": { opacity: 0.8 },
            "&:disabled": { opacity: 0.6, color: "#ccc" },
            cursor: SubmitLoading ? "not-allowed" : "pointer",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            textTransform: 'none',
          }}
          disabled={
            SubmitLoading ||
            !agreeToTerms ||
            !registerData.lastName ||
            !registerData.firstName ||
            PhoneRegisterPathway ||
            !registerData.email
          }
        >
          {t('Continue')}
          {SubmitLoading && (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-end",
              }}
            >
              <CircularProgress size={20} color="inherit" />
            </span>
          )}
        </Button>
      </form>
    </div>
  );

  const renderRegisterForm = () =>
    registerStep === 1 ? renderRegisterStep1() : renderRegisterStep2();

  const renderSmsCodeTab = () => (
    <>
      <h2 style={{ fontWeight: 700, fontSize: 32, marginBottom: 8 }}>
        {t('confirmPhoneNumber')}
      </h2>

      <div style={{ fontSize: 14, marginBottom: 10 }}>
        {t('VerficationSentSMS')} {PhoneRegisterData.phoneCode + PhoneRegisterData.phoneNumber2}：
      </div>
      <div style={VerificationCodeContainer}>
        {code.map((digit, index) => (
          <input
            key={index}
            type="tel"
            ref={(el) => (inputRefs.current[index] = el)}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            maxLength="1"
            style={VerificationCodeInput}
            autoComplete="off"
          />
        ))}
      </div>
      {formErrors2 && (<span style={errorMessageStyle}>{formErrors2}</span>)}
      <Button
        variant="contained"
        disabled={isDisabled}
        onClick={reGenerateSmsCode}
        sx={{
          width: "100%",
          padding: "12px",
          backgroundColor: "#31BACD",
          color: "#fff",
          "&:hover": { opacity: 0.8, backgroundColor: "#31BACD" },
          "&:disabled": { opacity: 0.6, backgroundColor: "#ccc" },
          border: "none",
          borderRadius: "10px",
          fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
          fontWeight: "bold",
          cursor: "pointer",
          marginTop: "10px",
          boxShadow: "none",
          textTransform: 'none',
        }}
      >
        {t('Resend')} {countdown > 0 ? " 00:" + (countdown < 10 ? "0" : "") + countdown : ""}
      </Button>
    </>
  );

  const renderEmailCodeTab = () => (
    <>
      <h2 style={{ fontWeight: 700, fontSize: 32, marginBottom: 8 }}>
        {t('confirmEmail')}
      </h2>

      <div style={{ fontSize: 14, marginBottom: 10 }}>
        {t('VerficationSentEmail')} {registerData.email}：
      </div>
      <div style={VerificationCodeContainer}>
        {code.map((digit, index) => (
          <input
            key={index}
            type="tel"
            ref={(el) => (inputRefs.current[index] = el)}
            value={digit}
            onChange={(e) => handleChange(index, e.target.value)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            maxLength="1"
            style={VerificationCodeInput}
            autoComplete="off"
          />
        ))}
      </div>
      {formErrors2 && (<span style={errorMessageStyle}>{formErrors2}</span>)}
      <Button
        variant="contained"
        disabled={isDisabled}
        onClick={reGenerateEmailCode}
        sx={{
          width: "100%",
          padding: "12px",
          backgroundColor: "#31BACD",
          color: "#fff",
          "&:hover": { opacity: 0.8, backgroundColor: "#31BACD" },
          "&:disabled": { opacity: 0.6, backgroundColor: "#ccc" },
          border: "none",
          borderRadius: "10px",
          fontSize: isMobile ? "var( --font-size-xs)" : "var(--font-size-base)",
          fontWeight: "bold",
          cursor: "pointer",
          marginTop: "10px",
          boxShadow: "none",
          textTransform: 'none',
        }}
      >
        {t('Resend')} {countdown > 0 ? "00:" + (countdown < 10 ? "0" : "") + countdown : ""}
      </Button>
    </>
  );

  const renderActiveForm = () => {
    switch (activeTab) {
      case "register":
        return renderRegisterForm();
      case "register-2":
        return renderRegisterStep2();
      case "register-sms-code-tab":
        return renderSmsCodeTab();
      case "register-email-code-tab":
        return renderEmailCodeTab();
      default:
        return renderRegisterForm();
    }
  };

  return (
    <div style={pageStyle}>
      <Navbar />
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh", // Full viewport height for centering
          }}
        >
          <Typography variant="h6" color="text.secondary">
            <img
              src="/icons/loading.gif"
              alt="Loading"
              style={{
                width: "150px",
                height: "auto",
                mixBlendMode: "multiply",
              }}
            />
            <div
              style={{
                fontWeight: "500px",
                fontSize: "15px",
                textAlign: "center",
                fontFamily: "Right Code,monospace",

              }}>
              {t('Loading')}
            </div>
          </Typography>
        </Box>
      ) : !isMobile ? (
        <div style={contentStyle}>
          <div style={{ position: "relative", height: "100vh" }}>
            <img
              src="/img/login.jpeg"
              alt="Login"
              style={catImageStyle}
              loading="eager"
            />
            <div style={desktopFormContainerStyle}>{renderActiveForm()}</div>
          </div>
        </div>
      ) : (
        <div style={contentStyle}>
          <div style={mobileBgStyle}>
            <div style={mobileFormContainerStyle}>{renderActiveForm()}</div>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
};

export default Login;
